import { PagesStore, PagesActions } from './types';

export const defaultState: PagesStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  pages: {},
  marketingPage: null,
  currentPageKey: null,
};

const reducer = (
  state: PagesStore = defaultState,
  action: { type: PagesActions; payload?: any }
): PagesStore => {
  switch (action.type) {
    case PagesActions.FetchPageBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case PagesActions.FetchPageError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case PagesActions.FetchPageSuccess: {
      if (!action.payload) {
        return state;
      }
      return {
        ...state,
        pages: { ...state.pages, ...action.payload.pages },
        currentPageKey: action.payload.currentPageKey,
        isLoading: false,
        isLoaded: true,
        error: null,
      };
    }
    case PagesActions.FetchMarketingPageBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case PagesActions.FetchMarketingPageError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case PagesActions.FetchMarketingPageSuccess: {
      return {
        ...state,
        marketingPage: action.payload,
        isLoading: false,
        isLoaded: true,
        error: null,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
